import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

// Import CSS
import "../node_modules/glightbox/dist/css/glightbox.min.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "./css/animate.css";
import "./css/style.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
